<div class="container-fluid">
    <div
        *ngFor="let entry of entries; let i = index"
        class="row entry-item"
        (click)="onClick(i, entry)"
        [ngClass]="{ 'entry-item--active': selectedEntryIndex === i }"
    >
        <span class="entry-item-value">
            {{ entry.recentlyCreated ? 'New Entry' : (entry.created_at | dateFormat : 'dateTime') }}
        </span>
        <div>
            <span *ngIf="allowMultipleEntries && entry.isDraft" class="draft-label"
                >draft<i class="chevron-right"></i
            ></span>
            <span class="nav-icon"></span>
        </div>
    </div>
    <div *ngIf="!entries.length" class="no-entry-block">No available entries</div>
</div>
